module.exports = __webpack_public_path__ + "img/water-green2.e30938d1.png";